export default "__VITE_PUBLIC_ASSET__5fc9be85__"